import React from "react";
import PropTypes from "prop-types";
import Formatter from "../Formatters/Formatters";

const Price = props => {
  const price = Formatter.numberToPrice(props.children, {
    showDecimals: props.showDecimals
  });

  return (
    <span className={props.className}>
      <span className={props.currencyClassName}>COP</span>{" "}
      <span className={props.valueClassName}>{price}</span>
    </span>
  );
};

Price.propTypes = {
  className: PropTypes.string,
  currencyClassName: PropTypes.string,
  valueClassName: PropTypes.string,
  children: PropTypes.number,
  showDecimals: PropTypes.bool
};

Price.defaultProps = {
  children: 0,
  showDecimals: true
};

export default Price;



// WEBPACK FOOTER //
// ./src/Price/Price.js